import { Component, ViewChild, ViewEncapsulation, TemplateRef } from '@angular/core';
import { FloatingMenuOption } from 'src/app/common/components/master-floating-menu/model/master-floating-model';
import { EmployeeExtService } from './employee-ext.service';
import { EmployeeCategoryModel } from '../employee-category/employee-category/model/employee-category.model';
import { MatDialog } from '@angular/material/dialog';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { ColumnFilter, RequestData, SearchSort } from 'src/app/common/models/request-data.model';
import { BreakpointObserver, BreakpointState, Breakpoints } from '@angular/cdk/layout';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { SelectionModel } from '@angular/cdk/collections';
import { FilterListItemModel, SearchFilterComponent, SearchParam } from 'src/app/common/components/search-filter/search-filter.component';
import { Router } from '@angular/router';
import { StateManagerService } from 'src/app/common/services/state.manager.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort, SortDirection } from '@angular/material/sort';
import { PermissionService } from 'src/app/auth/permission.service';


@Component({
  selector: 'app-employee-ext',
  templateUrl: './employee-ext.component.html',
  styleUrl: './employee-ext.component.scss',
  standalone: false
})
export class EmployeeExtComponent {
  employeeList: EmployeeCategoryModel[] = [];

  showSearch: boolean = false;
  isLoading = true;
  IsDownloading = false;
  isInitializing = true;
  employeeStatusesList: any[] = [];
  employeeJobPositionsList: any[] = [];
  employeeTypeList: any[] = [];

  filter: FilterListItemModel[] = [
    { title: "Id", column: "e.id" },
    { title: "Payroll Code", column: "e.code" },
    { title: "Name", column: "e.f_name" },
    { title: "Preferred Name", column: "e.preferred_name" },
    {
      title: "Gender", column: "e.gender", type: "list",
      values: [
        { title: "Male", value: "male" },

        { title: "Female", value: "female" },
      ]
    },
    {
      title: "Shop",
      column: "s.id",
      type: "list",
      operators: [
        { title: "in", operator: "in" },
        { title: "not in", operator: "not in" }
      ],
      values: []
    },
    {
      title: "Employee Type",
      column: "et.name",
      type: "list",
      includeFreeSearch: true,
      values: []
    },
    {
      title: "Job Position",
      column: "ejp.name",
      type: "list",
      includeFreeSearch: true,
      values: []
    },
    { title: "Phone", column: "e.phone" },
    { title: "Email", column: "e.email" },
    {
      title: "Status", column: "es.name", type: "list",
      includeFreeSearch: true,
      values: []
    },
    { title: "Card No", column: "e.card_no" },
    // Add more if you add more columns to displayedColumns
  ];
  displayedColumns = ['id', 'f_name', 'shop', 'payroll_code', 'gender', 'wage_type', 'job_position', 'phone', 'employee_status', 'action'];
  pagingData = { length: 0, pageSize: 10, pageIndex: 0 };
  menuOption: FloatingMenuOption = {
    add: true,
    search: false,
    export: true,
    more: true
  }

  isHandset: boolean = false;
  searchColumFilter: SearchParam = {};
  columnSortData: SearchSort[] = [];
  selectedItem?: EmployeeCategoryModel;
  showSummaryPanel: boolean = false;
  selection = new SelectionModel<EmployeeCategoryModel>(true, []);
  dataSource = new MatTableDataSource(this.employeeList);
  permission: any;
  tempCardNo: string = '';
  isQuickEditLoading: boolean = false;
  currentEditingEmployee: any;
  @ViewChild('quickEditDialog') quickEditDialog!: TemplateRef<any>;

  constructor(private breakpointObserver: BreakpointObserver,
    private employeeService: EmployeeExtService,
    private stateManagerService: StateManagerService,
    public dialog: MatDialog,
    public permissionService: PermissionService,
    private snackBarService: SnackBarService,
    private router: Router) {

    this.employeeList = [];
    this.permission = this.permissionService.getPagePermission('employee');
    this.permission.can_add = false;
    this.permission.can_delete = false;
    this.permission.can_edit = false;

    this.permission.can_export = false;

    this.loadEmployeeStatuses();
    this.loadEmployeeJobPositions();
    this.loadEmployeeTypes();
  }

  getAssignedShops(shopNamesStr: string): string[] {
    if (!shopNamesStr) return [];
    return shopNamesStr.split('||');
  }

  /**
    * initilaize the device model
    */
  ngOnInit(): void {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((state: BreakpointState) => {
      if (state.matches) {
        this.isHandset = true;
      } else {
        this.isHandset = false;
      }
    });
    this.initializeShopFilter();
    //this.loadRating();
    //this.loadData();
  }

  initializeShopFilter(): void {
    const userStr = sessionStorage.getItem('user');
    if (userStr) {
      try {
        const userData = JSON.parse(userStr);
        if (userData && userData.user_shops && userData.user_shops.length > 0) {
          const shopFilter = this.filter.find(f => f.column === 's.id' || f.column === 's.name');
          if (shopFilter) {
            shopFilter.column = 's.id';
            shopFilter.values = userData.user_shops.map((shop: any) => ({
              title: shop.name,
              value: shop.id !== undefined ? shop.id : shop.shop_id
            }));
          }
        }
      } catch (e) {
        console.error('Error parsing user session for shop filter:', e);
      }
    }
  }

  loadEmployeeStatuses(): void {
    const requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 100,
            offset: 0
          }
        },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };
    this.employeeService.getEmployeeStatusesList(requestData).subscribe({
      next: (response) => {
        if (response && response.status === 'SUCCESS') {
          const statuses = response.data.statuses || [];
          this.employeeStatusesList = statuses.map((s: any) => ({
            title: s.name,
            value: s.name
          }));
          const statusFilter = this.filter.find(f => f.column === 'es.name');
          if (statusFilter) {
            statusFilter.values = this.employeeStatusesList;
          }
        }
      },
      error: (err) => {
        console.error('Failed to load employee statuses', err);
      }
    });
  }

  loadEmployeeJobPositions(): void {
    const requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 100,
            offset: 0
          }
        },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };
    this.employeeService.getEmployeeJobPositionsList(requestData).subscribe({
      next: (response) => {
        if (response && response.status === 'SUCCESS') {
          const positions = response.data.job_positions || [];
          this.employeeJobPositionsList = positions.map((p: any) => ({
            title: p.name,
            value: p.name
          }));
          const positionFilter = this.filter.find(f => f.column === 'ejp.name');
          if (positionFilter) {
            positionFilter.values = this.employeeJobPositionsList;
          }
        }
      },
      error: (err) => {
        console.error('Failed to load employee job positions', err);
      }
    });
  }

  loadEmployeeTypes(): void {
    const requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: 100,
            offset: 0
          }
        },
        sort: [{ column: 'name', order: 'asc' }]
      }
    };
    this.employeeService.getEmployeeTypeList(requestData).subscribe({
      next: (response) => {
        if (response && response.status === 'SUCCESS') {
          const types = response.data.employee_types || [];
          this.employeeTypeList = types.map((t: any) => ({
            title: t.name,
            value: t.name
          }));
          const typeFilter = this.filter.find(f => f.column === 'et.name');
          if (typeFilter) {
            typeFilter.values = this.employeeTypeList;
          }
        }
      },
      error: (err) => {
        console.error('Failed to load employee types', err);
      }
    });
  }
  /** 
  * Set the datasource
  */
  setDataSource(employeeList: EmployeeCategoryModel[]) {
    this.dataSource = new MatTableDataSource(employeeList);
    this.dataSource.sort = this.sort;
  }
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('searchFilter') searchFilter!: SearchFilterComponent;
  ngAfterViewInit(): void {
    this.loadPreviousState();
    this.isInitializing = false;
  }

  /**
   * loads the previous state if exists
   */
  loadPreviousState(): void {

    var previousState = this.stateManagerService.getState(this.constructor.name);

    if (previousState !== undefined && this.searchFilter != undefined) {

      if (previousState.state.search.filters.scope) {
        this.pagingData.pageIndex = previousState.state.search.filters.scope.offset / previousState.state.search.filters.scope.limit;
        this.pagingData.pageSize = previousState.state.search.filters.scope.limit;
      }

      if (previousState.state.search.sort != undefined && previousState.state.search.sort.length > 0) {
        this.setSortColumn(previousState.state.search.sort[0].column, previousState.state.search.sort[0].order);
      }

      this.searchColumFilter = JSON.parse(JSON.stringify(previousState.state.search.filters));
      if (this.searchColumFilter && this.searchColumFilter.advSearch) {
        this.searchColumFilter.advSearch.forEach((f: any) => {
          if (f.column === 's.name') {
            f.column = 's.id';
            const userStr = sessionStorage.getItem('user');
            if (userStr) {
              try {
                const userData = JSON.parse(userStr);
                if (userData && userData.user_shops) {
                  if (Array.isArray(f.value)) {
                    f.value = f.value.map((v: any) => {
                      const found = userData.user_shops.find((s: any) => s.name === v || s.id === v || s.shop_id === v);
                      return found ? (found.id !== undefined ? found.id : found.shop_id) : v;
                    });
                  } else if (typeof f.value === 'string') {
                    const found = userData.user_shops.find((s: any) => s.name === f.value || s.id === f.value || s.shop_id === f.value);
                    if (found) f.value = found.id !== undefined ? found.id : found.shop_id;
                  }
                }
              } catch (e) {}
            }
          }
        });
      }
      this.searchFilter.setSearchFilter(this.searchColumFilter, true);

    } else {
      this.setSortColumn('f_name', 'asc');
      this.loadData();
    }

  }

  /**
   * Sets the sort column
   * @param column 
   * @param direction 
   */
  setSortColumn(column: string, direction: SortDirection): void {
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: column, order: direction });
    if (this.sort) {
      this.sort.sort({
        id: column,
        start: direction,
        disableClear: false,
      });
    }

    // this.sort.active=column;
    // this.sort.direction=direction;


  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.employeeList.length;
    return numSelected === numRows;
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.employeeList);
  }

  /**
   * Create sort order
   * @returns sort criteria
   */
  getSort(): SearchSort[] {
    return this.columnSortData;
  }

  /**
     * Builds the request data to be send to API
     * @returns Request Data
     */
  buildRequestData(): RequestData {
    let searchParam = this.getSearchParam();
    let requestData: RequestData = {
      search: {
        filters: {
          simpleSearch: searchParam.freeSearch,
          advSearch: [
            ...(searchParam.advSearch || []),
            ...this.getDefaultSearchParams(searchParam.advSearch),
          ],
          scope: {
            limit: this.pagingData.pageSize,
            offset: (this.pagingData.pageIndex * this.pagingData.pageSize),
          }
        },
        sort: this.getSort(),
      }
    };

    return requestData;
  }

  /**
   * Check and apply default filters for Shop and Area Manager logins.
   **/
  getDefaultSearchParams(searchFilter: any): ColumnFilter[] {
    var defFilter: any = [];
    if (
      searchFilter == undefined ||
      !searchFilter.some((sf: any) => sf.column == "s.id" || sf.column == "shop_id" || sf.column == "s.name")
    ) {
      const userStr = sessionStorage.getItem('user');
      if (userStr) {
        try {
          const user = JSON.parse(userStr);
          const userType = user.user_type ? user.user_type.toUpperCase() : '';

          if (userType === 'SHOP') {
            const shopId = user.shop_id || (user.user_shops && user.user_shops[0] ? user.user_shops[0].id : null);
            if (shopId) {
              defFilter.push({
                column: "s.id",
                operator: "=",
                value: shopId
              });
            }
          } else if (userType === 'AREA_MANAGER' || userType === 'AREA') {
            const userShops = user.user_shops || [];
            if (userShops.length > 0) {
              const shopIds = userShops.map((s: any) => s.id !== undefined ? s.id : s.shop_id);
              defFilter.push({
                column: "s.id",
                operator: "in",
                value: shopIds
              });
            }
          }
        } catch (e) {
          console.error('Error parsing user session in getDefaultSearchParams:', e);
        }
      }
    }
    return defFilter;
  }

  /**
    * Set the column filter and reaload the daaa
    * @param columFilter 
    */

  onFilterApplied(columFilter: any): void {
    this.searchColumFilter = columFilter;
    this.loadData();

  }

  /**
    * On delete menu item selected
    * Confirm the action and call the api to update
    */
  onDelete(employeeInfo: EmployeeCategoryModel): void {
    const areaId = employeeInfo.id;
    const message = `Are you sure, you want to delete ` + (employeeInfo.name + "?");
    const dialogData = new ConfirmDialogModel("Confirm Deletion", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      console.log(dialogResult);
      if (dialogResult) {
        this.employeeService.delete(employeeInfo).subscribe({
          next: (response) => {
            if (response.status == 'SUCCESS') {
              // handle success
              let snckBarData: SnackBarData = {
                type: 'success',
                title: 'Saved',
                message: 'The record for ' + employeeInfo.name + " has been deleted succesfully."
              }

              this.loadData();
            } else {
              let snackBarData: SnackBarData = {
                message: response.message,
                title: 'Failed!!!',
                type: 'error'
              }
              this.snackBarService.openSnackBar(snackBarData);
            }
          },
          error: (error) => {
            let snackBarData: SnackBarData = {
              message: 'Failed to update. Connection to the server failed',
              title: 'Failed!!!',
              type: 'error'
            }
            this.snackBarService.openSnackBar(snackBarData);
          }
        });
      }
    });
  }

  /**
   * loads the data based on the conditions
   */

  loadData(): void {
    this.isLoading = true;
    let requestData = this.buildRequestData();
    let response = this.employeeService.getEmployeeList(requestData).subscribe(response => {
      if (response.status == 'SUCCESS') {
        const mappedEmployees = (response.data.employees || []).map((emp: any) => ({
          ...emp,
          id: emp.employee_id || emp.id,
          code: emp.code,
          f_name: emp.first_name || emp.f_name,
          m_name: emp.middle_name || emp.m_name,
          l_name: emp.last_name || emp.l_name,
          status: emp.employee_status === 'Active' ? '1' : (emp.status || '2'),
          sex: emp.gender === 'male' ? 'M' : (emp.gender === 'female' ? 'F' : emp.sex),
          gender: emp.gender ? (emp.gender.charAt(0).toUpperCase() + emp.gender.slice(1).toLowerCase()) : emp.gender,
          phone: emp.phone_mobile || emp.phone,
          email: emp.email || emp.work_email,
          wage_type: emp.employee_type === 'Full-time' ? '2' : (emp.wage_type || '1')
        }));

        this.employeeList = mappedEmployees;
        this.setDataSource(mappedEmployees);

        this.pagingData.length = response.data.total_count || mappedEmployees.length;
        if (this.pagingData.length == 0) {
          let snackBarData: SnackBarData = {
            message: 'No data found. Please remove or change the filter if any.',
            title: 'No Data!!!',
            type: 'warn'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.selectedItem = undefined;
        } else {
          this.onRowSelected(this.employeeList[0])
          this.stateManagerService.setState(this.constructor.name, requestData);
        }
      } else {
        let snackBarData: SnackBarData = {
          message: response.message,
          title: 'Failed!!!',
          type: 'error'
        }
        this.snackBarService.openSnackBar(snackBarData);
      }
      this.isLoading = false;
    });

  }

  /**
  * On employeeInfo selected
  * @param employeeInfo 
  */
  onRowSelected(employeeInfo: EmployeeCategoryModel): void {
    this.selectedItem = employeeInfo;
    this.showSummaryPanel = true;
  }

  /**
    *  Set the sort param and relead the data
    * @param $event sort data
    * {"active": "email","direction": "asc"}
    *   
    */
  sortData($event: any): void {
    var sd = this.sort;
    this.columnSortData.length = 0;
    this.columnSortData.push({ column: sd.active, order: sd.direction });
    if (!this.isInitializing) {
      this.loadData();
    }
  }
  /**
* Creates the column filter conditions based on search criteria
* @returns Filter condions for columns
*/
  getSearchParam(): SearchParam {

    return this.searchColumFilter;
  }

  /**
 * On edit the item
 * Show the edit dialog
 */
  onEdit(employeeInfo: EmployeeCategoryModel): void {

    this.router.navigate(['employee/employee-ext-edit', employeeInfo.id]);
  }


  /**
   * 
   * @param event 
   * When page size is changed update paging data
   */
  onePageEvent(event: any): void {

    this.pagingData.pageIndex = event.pageIndex;
    this.pagingData.pageSize = event.pageSize;

    this.loadData();

  }

  /**
   * On Add clicked
   * Show the dialog to enter new area
   */
  addClicked(): void {

    this.router.navigate(['employee/employee-ext-edit', 0]);

  }
  exportClicked() {
    if (this.pagingData.length === 0) {
      let snackBarData: SnackBarData = {
        message: 'No data found to export. Please remove or change the filter if any.',
        title: 'No Data!!!',
        type: 'warn'
      };
      this.snackBarService.openSnackBar(snackBarData);
      return;
    }
    this.isLoading = true;
    let requestData = this.buildRequestData();
    this.IsDownloading = true;
    this.employeeService.downloadExcel(requestData)
      .subscribe({
        next: blob => {
          // Download logic
          this.IsDownloading = false;
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'employeecategory.csv'; // Adjust filename if needed
          link.click();
          window.URL.revokeObjectURL(url);
          this.isLoading = false;


        },
        error: error => {
          // Handle errors
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
          this.isLoading = false;
          // Display user-friendly error message to the user
        }
      }
      );
  }



  openQuickEdit(employee: any): void {
    this.currentEditingEmployee = employee;
    this.tempCardNo = employee.card_no;
    this.isQuickEditLoading = false;

    this.dialog.open(this.quickEditDialog, {
      width: '350px',
      disableClose: true
    });
  }

  saveQuickEdit(): void {
    if (this.tempCardNo && this.tempCardNo.trim() !== '') {
      this.isQuickEditLoading = true;
      const payload = {
        employee_id: this.currentEditingEmployee.id,
        card_no: this.tempCardNo
      };

      this.employeeService.update(payload).subscribe({
        next: (res) => {
          this.isQuickEditLoading = false;
          if (res.status === 'SUCCESS') {
            this.snackBarService.openSnackBar({
              message: 'Card number updated successfully',
              title: 'Success',
              type: 'success'
            });
            this.currentEditingEmployee.card_no = this.tempCardNo;
            this.setDataSource([...this.employeeList]);
            this.dialog.closeAll();
          } else {
            this.snackBarService.openSnackBar({
              message: res.message || 'Failed to update card number',
              title: 'Error',
              type: 'error'
            });
          }
        },
        error: (err) => {
          this.isQuickEditLoading = false;
          this.snackBarService.openSnackBar({
            message: 'An error occurred while updating card number',
            title: 'Error',
            type: 'error'
          });
        }
      });
    }
  }
}

